export const createDirectorTypeForm = () => ({
    name: '',
    display: '',
    sortOrder: 0,
});
